import { useState } from "react"

const flow = {
  label: "Ideia da Mudança ou Melhoria",
  type: "decision",
  options: [
    {
      label: "Sim",  // caminho da direita → Preparar documentação
      next: {
        label: "Preparar documentação e procedimentos específicos",
        next: {
          label: "Análise de Risco",
          type: "decision",
          options: [
            {
              label: "Aceito",
              next: {
                label: "Plano e implementação da mudança",
                next: {
                  label: "Implementação da mudança",
                  type: "decision",
                  options: [
                    {
                      label: "Sim",
                      next: {
                        label: "Testes e verificações",
                        next: {
                          label: "Todas etapas / verificações conforme?",
                          type: "decision",
                          options: [
                            {
                              label: "Sim",
                              next: {
                                label: "Aprovar RSPPP → Finalizar MOC → Arquivar MOC → FIM"
                              }
                            },
                            {
                              label: "Não",
                              next: {
                                label: "Correção dos desvios → voltar para testes"
                              }
                            }
                          ]
                        }
                      }
                    },
                    {
                      label: "Não",
                      next: { label: "Documentação atualizada + Abrir ação de atualização" }
                    }
                  ]
                }
              }
            },
            {
              label: "Não aceito",
              next: { label: "Parar a mudança" }
            }
          ]
        }
      }
    },
    {
      label: "Não",  // caminho da esquerda → Mudança Organizacional?
      next: {
        label: "Mudança Organizacional?",
        type: "decision",
        options: [
          {
            label: "Sim",
            next: { label: "Abrir MOOC na plataforma" }
          },
          {
            label: "Não",
            next: {
              label: "Projeto?",
              type: "decision",
              options: [
                {
                  label: "Sim",
                  next: { label: "Abrir projeto conforme Procedimento" }
                },
                {
                  label: "Não",
                  next: {
                    label: "Consultar o Expert da área",
                    next: { label: "Abrir MOC na plataforma" }
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
}

const NODE_WIDTH = 250
const NODE_HEIGHT = 100
const H_SPACING = 280
const V_SPACING = 130

function NodeShape({ node, x, y, selected }) {
  const stroke = selected ? "#007bff" : "#333"
  const fill = selected ? "#e3f2fd" : "#fff"

  return node.type === "decision" ? (
    <polygon
      points={`
        ${x},${y - NODE_HEIGHT / 2}
        ${x + NODE_WIDTH / 2},${y}
        ${x},${y + NODE_HEIGHT / 2}
        ${x - NODE_WIDTH / 2},${y}
      `}
      fill={fill}
      stroke={stroke}
      strokeWidth="2"
    />
  ) : (
    <rect
      x={x - NODE_WIDTH / 2}
      y={y - NODE_HEIGHT / 2}
      width={NODE_WIDTH}
      height={NODE_HEIGHT}
      rx={10}
      fill={fill}
      stroke={stroke}
      strokeWidth="2"
    />
  )
}

function Arrow({ x1, y1, x2, y2 }) {
  return (
    <line
      x1={x1}
      y1={y1}
      x2={x2}
      y2={y2}
      stroke="#333"
      strokeWidth="2"
      markerEnd="url(#arrow)"
    />
  )
}

export default function FlowDiagram() {
  const [path, setPath] = useState({})

    const handleSelect = (nodeId, optionIndex) => {
    setPath(prev => {
        const isSame = prev[nodeId] === optionIndex

        // se clicou na mesma opção → remove (toggle OFF)
        if (isSame) {
        const newPath = { ...prev }
        delete newPath[nodeId]
        return newPath
        }

        // se clicou em outra → troca normalmente (toggle ON)
        return {
        ...prev,
        [nodeId]: optionIndex,
        }
    })
    }

  function renderNode(node, x, y, nodeId = "root") {
    const selectedIndex = path[nodeId]

    return (
      <g key={nodeId}>
        {/* Arrow marker */}
        {nodeId === "root" && (
          <defs>
            <marker
              id="arrow"
              markerWidth="10"
              markerHeight="10"
              refX="6"
              refY="3"
              orient="auto"
            >
              <path d="M0,0 L0,6 L9,3 z" fill="#333" />
            </marker>
          </defs>
        )}

        {/* Shape */}
        <NodeShape
          node={node}
          x={x}
          y={y}
          selected={selectedIndex !== undefined}
        />

        {/* Texto */}
        <foreignObject
          x={x - NODE_WIDTH / 2}
          y={y - NODE_HEIGHT / 2}
          width={NODE_WIDTH}
          height={NODE_HEIGHT}
        >
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              fontSize: "12px",
              padding: "6px",
              boxSizing: "border-box",
              wordBreak: "break-word",
            }}
          >
            {node.label}
          </div>
        </foreignObject>

        {/* DECISÕES */}
        {node.options &&
          node.options.map((opt, i) => {
            const childX =
              x + (i === 0 ? -H_SPACING / 2 : H_SPACING / 2)
            const childY = y + V_SPACING

            const isSelected = selectedIndex === i
            const hasSelection = selectedIndex !== undefined
            const isDisabled = hasSelection && !isSelected

            // 🔥 POSICIONAMENTO DO BOTÃO (lado da linha)
            const midX = (x + childX) / 2
            const midY = (y + childY) / 2

            const offset = 40
            const direction = childX > x ? 1 : -1

            const buttonX = midX + direction * offset
            const buttonY = midY

            return (
              <g key={i}>
                {/* BOTÃO */}
                <g
                onClick={() => handleSelect(nodeId, i)}
                style={{
                    cursor: "pointer",
                    opacity: isDisabled ? 0.5 : 1,
                }}
                >
                <rect
                    x={buttonX - 30}
                    y={buttonY - 12}
                    width="60"
                    height="24"
                    rx="6"
                    fill={isSelected ? "#007bff" : "#fff"}
                    stroke={isDisabled ? "#999" : "#007bff"}
                />

                <text
                    x={buttonX}
                    y={buttonY + 4}
                    textAnchor="middle"
                    fontSize="12"
                    fill={
                    isSelected
                        ? "#fff"
                        : isDisabled
                        ? "#666"
                        : "#007bff"
                    }
                    fontWeight="bold"
                    pointerEvents="none"
                >
                    {opt.label}
                </text>
                </g>

                {/* SETA + FILHO */}
                {isSelected && (
                  <>
                    <Arrow
                      x1={x}
                      y1={y + NODE_HEIGHT / 2}
                      x2={childX}
                      y2={childY - NODE_HEIGHT / 2}
                    />

                    {renderNode(
                      opt.next,
                      childX,
                      childY,
                      `${nodeId}-${i}`
                    )}
                  </>
                )}
              </g>
            )
          })}

        {/* FLUXO LINEAR */}
        {node.next && (
          <>
            <Arrow
              x1={x}
              y1={y + NODE_HEIGHT / 2}
              x2={x}
              y2={y + V_SPACING - NODE_HEIGHT / 2}
            />

            {renderNode(node.next, x, y + V_SPACING, `${nodeId}-next`)}
          </>
        )}
      </g>
    )
  }

const getFlowHeight = () => {
  const levels = 10 // estimativa ou cálculo baseado no path
  return levels * V_SPACING + 200
}

  return (
    <div style={{ height: "calc(100vh - 50px)", overflowY: "auto", overflowX: "auto" }}>
      <svg width="100%" height={getFlowHeight()} viewBox="-200 0 1500 1500">
        {renderNode(flow, 600, 80)}
      </svg>
    </div>
  )
}